import { render, staticRenderFns } from "./Dept.vue?vue&type=template&id=0a848ae6&scoped=true&"
import script from "./Dept.vue?vue&type=script&lang=js&"
export * from "./Dept.vue?vue&type=script&lang=js&"
import style0 from "./Dept.vue?vue&type=style&index=0&id=0a848ae6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a848ae6",
  null
  
)

export default component.exports